// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 6.4998V17.4998L1 17.5L1 6.5L5 6.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 18.2099L15.0004 22.7095L15.0004 1.29004L7 5.7896V18.2099Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21.1569 6.34285L20.4497 5.63574L19.0355 7.04996L19.7426 7.75706C22.0858 10.1002 22.0858 13.8992 19.7426 16.2423L19.0355 16.9495L20.4497 18.3637L21.1569 17.6566C24.2811 14.5324 24.2811 9.46704 21.1569 6.34285Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.682 7.40351L17.2678 8.81772L17.9749 9.52483C19.3417 10.8917 19.3417 13.1077 17.9749 14.4746L17.2678 15.1817L18.682 16.5959L19.3891 15.8888C21.537 13.7409 21.537 10.2585 19.3891 8.11062L18.682 7.40351Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.6213 14.121C18.7929 12.9495 18.7929 11.05 17.6213 9.87838L16.9142 9.17128L15.5 10.5855L16.2071 11.2926C16.5976 11.6831 16.5976 12.3163 16.2071 12.7068L15.5 13.4139L16.9142 14.8281L17.6213 14.121Z"}}]};

const SoundHighFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-high-filled',
    ref,
    icon: element,
  },
));

SoundHighFilledIcon.displayName = 'SoundHighFilledIcon';

export default SoundHighFilledIcon;
